import { render, staticRenderFns } from "./ObservatoryWindLayer.vue?vue&type=template&id=0825e8c9&"
import script from "./ObservatoryWindLayer.vue?vue&type=script&lang=js&"
export * from "./ObservatoryWindLayer.vue?vue&type=script&lang=js&"
import style0 from "./ObservatoryWindLayer.vue?vue&type=style&index=0&id=0825e8c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports